<template>
  <div>
    <md-card class="search-area">
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>search</md-icon>검색 조건
        </h4>
      </md-card-header>
      <md-card-content>
        <table class="flex-table">
          <tr>
            <th>경조구분</th>
            <td>
              <select v-focus v-model="query.kyjoCd" name="kyjoCd">
                <option value="">-- 선택 --</option>
                <option v-for="item in kyjoCdList" :key="item.code" :label="item.codeNm" :value="item.code">{{ item }}</option>
              </select>
            </td>
            <th>기타</th>
            <td>
              <input type="text" v-model="query.prizeEtc">
            </td>
            <th>행사 시작일</th>
            <td>
              <div class="inline-flex">
                <input type="text" v-model="query.startDate" v-mask="'####-##-##'">
              </div>
            </td>
            <th>행사 종료일</th>
            <td>
              <div class="inline-flex">
                <input type="text" v-model="query.endDate" v-mask="'####-##-##'">
              </div>
            </td>
          </tr>
        </table>
      </md-card-content>
        <md-card-actions md-alignment="right">
          <md-button class="md-info md-sm" @click="sendQuery">
            <md-icon>check</md-icon>검 색
          </md-button>
          <md-button class="md-success md-sm" @click="downloadExcel" v-exel-btn="[5,3]" :disabled="this.pagination.total === 0">
            <md-icon>get_app</md-icon>Excel 다운로드
          </md-button>
        </md-card-actions>
    </md-card>



    <!-- 목록 시작 -->
    <md-card>
      <md-card-header md-alignment="space-between">
        <h4 class="title">
          <md-icon>assignment</md-icon>
          검색 결과
        </h4>
      </md-card-header>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
          <div>
            <select v-model="pagination.perPage" name="pages" @change="perPageChange">
              <option v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <grid ref="eventListGrid"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :theme="gridProps.theme"
              :rowHeaders="gridProps.rowHeaders"
              :columnOptions="gridProps.columnOptions"
              :language="gridProps.lang"
              @click="onClickEvent"
              @response="response"
        ></grid>

      </md-card-content>

      <slot name="bottomRightArea"></slot>
    </md-card>
  </div>
</template>
<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";
import moment from "moment";


import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';

export default {
  name: "familyEventListComp",

  props: {
  },

  components: {
    grid: Grid
  },

  created() {
    this.getkyjoCDList();
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      query : {
        kyjoCd : '',
        prizeEtc : '',
        startDate : null,
        endDate : null
      },
      kyjoCdList : [],
      tableData : [],

      joinerCntNm : "joinerCnt", // 참가자 수 컬럼명
      eventTitleNm : "eventTitle", // 행사명 컬럼명
      eventListQuery : {
        startDate : null,
        endDate : null,
        eventTitle : ''
      },
      gridProps: {},
      pagination: {
        perPage: 50,
        page: 1,
        perPageOptions: [50, 100, 200, 500],
        total: 0
      },
    };
  },
  methods: {
    getkyjoCDList (){
      kuaaFnc.fnckyjoCodes(null,res => {
        this.kyjoCdList = res.data.data.contents;
      });
    },

    sendQuery (){
      let params = JSON.parse(JSON.stringify(this.query));
      params['startDate'] = this.customFormatter(params['startDate']);
      params['endDate'] = this.customFormatter(params['endDate']);

      //this.$refs.eventListGrid.invoke("readData", this.$refs.eventListGrid.invoke("getPagination")._currentPage, params);
      this.$refs.eventListGrid.invoke("readData", 1, params);
      this.$emit('returnSearchCallback');
    },
    customFormatter(date) {
      let res = date && date != '' ? moment(date).format("YYYYMMDD") : '';
      return res;
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_PRIZE_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.eventListGrid;
      this.gridProps['columns'] = [
          {header: '경조구분', name: 'kyjoCdNm', align : 'center', sortable: true},
          {header: '교우번호', name: 'prizeMem', align : 'center', sortable: true},
          {header: '성명', name: 'memberHnm', align : 'center', sortable: true},
          {header: '학과', name: 'classNm', width:120, sortable: true},
          {header: '학번', name: 'hakbun', align : 'center', sortable: true},
          {header: '기타행사', name: 'prizeEtc', sortable: true},
          {header: '접수내용', name: 'remark', width:120, sortable: true},
          {header: '장소', name: 'place', sortable: true},
          {header: '행사일시', name: 'useDate', align : 'center', widht:100, sortable: true},
          {header: '조치', name: 'actCdNm', align : 'center', width:200, sortable: true},
          {header: '리본내용', name: 'ribbonCont', widht:200, sortable: true},
          {header: '발송명의', name: 'fromNm', align : 'center', sortable: true},
          {header: '의뢰', name: 'request', align : 'center', sortable: true},
          {header: '주문일자', name: 'orderDate', align : 'center',widht:100, sortable: true},
          {header: '업체', name: 'storeCdNm', sortable: true},
          {header: '금액', name: 'amt', align : 'right', sortable: true, formatter(value) {return formatter.getCurrency(value.value);}},
          {header: '포상코드', name: 'prizeCd', hidden:true}
        ];
      this.gridProps['options'].bodyHeight = 540;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.eventListGrid, event, this.pagination);
    },
    response(e) {
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.pagination.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e);
      }
      this.$emit('returnPagingResult', this.pagination);
      this.$emit('returnQueryResult', this.query);
    },
    /**
     * 그리드 클릭
     */
    onClickEvent(e) {
      if(e.instance.getRow(e.rowKey) != null) {
        this.$emit('returnResult', e.instance.getRow(e.rowKey));
      }
    },

    downloadExcel() {
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '경조사관리';
      kuaaApi.requestFileDownload(
          URL_CONST.PRIZE_EXCEL_DOWNLOAD,
          this.query,
          '경조사관리.xlsx',
          response => {
            this.query.page = this.pagination.page;
            this.query.perPage = this.pagination.perPage;
          }
      );
    }
  }
};
</script>

<style lang="css" scoped>
</style>